export default function getFullName(user) {
  if (user) {
    const name = user.name ? user.name : ''
    const surname = user.surname ? user.surname : ''

    return `${name} ${surname}`.trim()
  }

  return ''
}
